export { DMS_MODULE } from '../constants';
export const NAME = 'PendingJobsAndSafetyList';
export const API_NAME = 'PendingJobsAndSafetyList';
export const EXPORT_FILE_NAME='PendingJobsAndSafetyList.xlsx';
export const CRUMB_LABEL_KEY = 'PendingJobsAndSafetyList';
export const addThreeMonths = 3;
export const subtractOneDay = 1;

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
